<style>
  .DownLoaded{
    background-color:#ff9595 !important;
  }

  .Uploaded{
    background-color:#a595ff  !important;
  }

  .Certificate{
    background-color:#95ff9e  !important;
  }


</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات همکاران</h5>
     <br/>
     <br>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
       <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام مشتری	</label>
          <input [(ngModel)]="Filter_customer"  name="Filter_customer" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> شماره رسید </label>
          <input [(ngModel)]="Filter_code"  name="Filter_customer" type="number" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

     <br/>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Colleague(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="Procssing" type="button"  class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید ...  <i class="fa fa-spin fa-spinner"></i> </button>
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره رسید</th>
              <th>نام مشتری</th>
              <th>نام پیمانکار</th>
              <th>موضوع نامه</th>
              <th>تاریخ ثبت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Colleague
            | paginate
                    : {
                        id: 'DataList_ColleagueTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Colleague).length
                      }
            ">
             <td>{{DataList_Colleague.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.contractName}} - {{item.contractCustomerName}} </td>
              <td>{{item.subject}} </td>
              <td>{{item.persianDate}} </td>

              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a  style="cursor: pointer;" target="_blank"  href="{{item.pdf}}" class="dropdown-item" ><i class="fa fa-file-pdf-o"></i> PDF </a>

                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_ColleagueTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>
